import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import IntlMessages from '../../components/IntlMessage';
import { Button, Table, Modal, Row, Col, Card, Tag, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import moment from 'moment-timezone';
import operatorsApi from '../../api/operators';
import UpdateAsignForm from './UpdateAsignForm';
import OperatorsForm from './OperatorsForm';
moment.tz.setDefault('US/Eastern');

OperatorFleets.propTypes = {
  items: PropTypes.array,
};
OperatorFleets.defaultProps = {
  items: [],
};

function OperatorFleets(props) {
  const { onClose, open, operatorId } = props;

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [isJobOpen, setIsJobOpen] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    filter_name: ['parent_operator_id'],
    filter_value: [operatorId],
  });
  const [modal, setModal] = useState(false);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await operatorsApi.getAllFleet(filter);
      setItems(items.data);
      setLoading(false);
      setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, deleting, reload]);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };
  const intl = useIntl();
  const onRemove = (data) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'global.delete_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await operatorsApi.delete(data.id).catch((error) => {
          console.error(error);
          Modal.error({
            title: error.data.message,
            okText: intl.formatMessage({ id: 'global.close' }),
          });
          setLoading(false);
        });
        setDeleting(true);
      },
      onCancel() {},
    });
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const handleOpenJobModal = (id) => {
    setIsJobOpen(true);
    setCustomerId(id);
  };

  const onChangeStatus = async (ischecked, record) => {
    Modal.confirm({
      title: ischecked
        ? intl.formatMessage({ id: 'global.activate_confirm' })
        : intl.formatMessage({ id: 'global.deactivate_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await operatorsApi
          .updateStatus(record.id, { status: ischecked })
          .then((res) =>
            setItems((items) =>
              items.map((data) => {
                if (data.id === record.id)
                  return {
                    ...data,
                    status: ischecked,
                  };
                return data;
              })
            )
          )
          .catch((err) => {
            Modal.error({
              title: err.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
          });
      },
      onCancel() {},
    });
  };

  const [modalAsign, setModalAsign] = useState(false);
  const [idOperator, setIdOperator] = useState(null);

  const onCloseModalAsign = () => {
    setModalAsign(false);
  };

  const onOpenModalAsign = (record = null) => {
    setModalAsign(true);
    setIdOperator(record.id);
  };

  const columns = [
    {
      title: <IntlMessages id="global.id" />,
      key: 'id',
      width: 20,
      sorter: true,
      dataIndex: 'id',
      render: (text, record) => {
        return record.id;
      },
    },
    {
      title: <IntlMessages id="global.title" />,
      key: 'title',
      dataIndex: 'title',
      render: (text, record) => {
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => onOpenModal(record)}
          >
            {record.title}
          </Button>
        );
      },
    },
    {
      title: <IntlMessages id="global.fullname" />,
      key: 'firstname',
      dataIndex: 'firstname',
      render: (text, record) => {
        return `${record.firstname} ${record.lastname}`;
      },
    },
    {
      title: <IntlMessages id="global.email" />,
      key: 'email',
      dataIndex: 'email',
      render: (text, record) => {
        return record.email ? record.email : null;
      },
    },
    {
      title: <IntlMessages id="global.phone" />,
      key: 'mobile',
      dataIndex: 'mobile',
      render: (text, record) => {
        return record.phone_code
          ? `(${record.phone_code}) ${record.mobile}`
          : record.mobile;
      },
    },

    {
      title: <IntlMessages id="global.belongto" />,
      dataIndex: 'belong_to',
      width: 100,
      key: 'belong_to',
      render: (e, record) => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <span>
            {record?.belong_to === 'QbicYard' ? (
              <Tag color="green">{`QbicYard`}</Tag>
            ) : (
              record?.store?.name
            )}
          </span>
          <Button
            type="primary"
            size="small"
            style={{ marginTop: '2px' }}
            onClick={() => onOpenModalAsign(record)}
            shape="round"
          >
            <IntlMessages id="global.update" />
          </Button>
        </div>
      ),
    },

    {
      title: <IntlMessages id="global.status" />,
      dataIndex: 'status',
      key: 'status',
      render: (e, record) =>
        record ? (
          <Switch
            checkedChildren=""
            unCheckedChildren=""
            checked={record.status}
            onChange={(ischecked) => onChangeStatus(ischecked, record)}
          />
        ) : null,
    },

    {
      title: 'Delete',
      render: (text, record) => {
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => onRemove(record)}
            danger
            shape="round"
            icon={<DeleteOutlined />}
          ></Button>
        );
      },
    },
  ];

  return (
    <Modal
      title="Users"
      visible={open}
      destroyOnClose={true}
      onCancel={() => onClose()}
      width="80%"
      onOk={() => onClose()}
    >
      <Card bordered={false} style={{ minHeight: '100%' }}>
        <Row justify="space-between" style={{ marginBottom: '1rem' }}>
          <Col></Col>
          <Col>
            <ActionBar
              isShowAddButton={true}
              onAdd={onOpenModal}
              onRefresh={() => onReload()}
              isShowPublishButtons={false}
              isShowCopyButton={false}
              isShowDeleteButton={false}
            ></ActionBar>
          </Col>
        </Row>

        <Table
          tableLayout="auto"
          columns={columns}
          dataSource={items}
          onChange={onChangeTable}
          rowKey="id"
          size="small"
          loading={loading}
          scroll={{
            x: 'max-content',
          }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            total: total,
            current: filter.page,
            pageSize: filter.limit,
          }}
        />

        {modalAsign ? (
          <UpdateAsignForm
            open={modalAsign}
            onClose={onCloseModalAsign}
            idOperator={idOperator}
            onReload={onReload}
          />
        ) : null}

        {modal ? (
          <OperatorsForm
            open={modal}
            onClose={onCloseModal}
            currentData={item}
            onReload={onReload}
            parentOperatorId={operatorId}
          />
        ) : null}
      </Card>
    </Modal>
  );
}

export default OperatorFleets;
